// extracted by mini-css-extract-plugin
export default {"markdown":"markdown_markdown__GAE7C","code":"markdown_code__bPS22","codeBlock":"markdown_codeBlock__P5NWs","mark":"markdown_mark__YY1vO"};